import React from 'react';

const LoaderContext = React.createContext({
    showLoader: false,
    loaderVisibility: (arg: boolean) => {}
  });


 export default LoaderContext;
